import * as firebase from 'firebase/app'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import { ICompany } from 'interfaces/ICompany'
import { nameof } from 'utils'

class CompanyEditor extends React.Component<
  RouteComponentProps<{ id: string }>,
  { company: ICompany }
> {
  public state: { company: ICompany } = {
    company: {
      adress: '',
      banknumber: '',
      banktype: 'PG' as ICompany['banktype'],
      city: '',
      email: '',
      iban: '',
      momsnr: '',
      name: '',
      orgnr: '',
      paymentdays: 30,
      phone: '',
      short: '',
      zip: '',
      web: '',
      swift: '',
      currencies: ['SEK'],
      style: 'alex',
    },
  }

  public async componentDidMount() {
    const { currentUser } = firebase.auth()

    if (this.props.match.params.id && currentUser) {
      const snapshot = await firebase
        .database()
        .ref(`/company/${currentUser.uid}/${this.props.match.params.id}`)
        .once('value')

      this.setState({ company: snapshot.val() as ICompany })
    }
  }

  public handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const { currentUser } = firebase.auth()
    const { id } = this.props.match.params

    if (!currentUser) {
      throw new Error('No UID')
    }

    if (id) {
      firebase
        .database()
        .ref(`/company/${currentUser.uid}/${id}`)
        .set(this.state.company)
        .then(() => this.props.history.push('/company'))
    } else {
      firebase
        .database()
        .ref(`/company/${currentUser.uid}`)
        .push(this.state.company)
        .then(() => this.props.history.push('/company'))
    }
  }

  public handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) =>
    this.setState({
      company: {
        ...this.state.company,
        [e.currentTarget.name]: e.currentTarget.value,
      },
    })

  public render() {
    const { state } = this
    return (
      <form onSubmit={this.handleSubmit}>
        <h3>Företag</h3>
        <input
          type="text"
          name={nameof<ICompany>('name')}
          value={state.company.name}
          style={{ fontSize: 14 }}
          onChange={this.handleChange}
          required
        />
        <div className="spacer" />
        <h3>Adress</h3>
        <input
          type="text"
          name={nameof<ICompany>('adress')}
          value={state.company.adress}
          onChange={this.handleChange}
          required
        />
        <div className="spacer" />
        <h3>Postnummer</h3>
        <input
          type="text"
          name={nameof<ICompany>('zip')}
          value={state.company.zip}
          onChange={this.handleChange}
          required
        />
        <div className="spacer" />
        <h3>Ort</h3>
        <input
          type="text"
          name={nameof<ICompany>('city')}
          value={state.company.city}
          onChange={this.handleChange}
          required
        />
        <div className="spacer" />
        <h3>Telefon</h3>
        <input
          type="text"
          name={nameof<ICompany>('phone')}
          value={state.company.phone}
          onChange={this.handleChange}
          required
        />
        <div className="spacer" />
        <h3>Email</h3>
        <input
          type="text"
          name={nameof<ICompany>('email')}
          value={state.company.email}
          onChange={this.handleChange}
          required
        />
        <div className="spacer" />
        <h3>Web</h3>
        <input
          type="text"
          name={nameof<ICompany>('web')}
          value={state.company.web}
          onChange={this.handleChange}
        />
        <div className="spacer" />
        <div className="divider" />
        <div className="spacer" />
        <h3>Organisationsnummer</h3>
        <input
          type="text"
          name={nameof<ICompany>('orgnr')}
          value={state.company.orgnr}
          onChange={this.handleChange}
        />
        <div className="spacer" />
        <h3>Momsnummer</h3>
        <input
          type="text"
          name={nameof<ICompany>('momsnr')}
          value={state.company.momsnr}
          onChange={this.handleChange}
          required
        />
        <div className="spacer" />
        <h3>Banktyp</h3>
        <select
          name={nameof<ICompany>('banktype')}
          value={state.company.banktype}
          onChange={this.handleChange}
        >
          <option value="PG">PlusGiro</option>
          <option value="BG">BankGiro</option>
          <option value="Konto">Konto</option>
        </select>
        <div className="spacer" />
        <div
          style={{
            display: 'flex',
            width: 608,
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h3>Banknummer</h3>
            <input
              type="text"
              name={nameof<ICompany>('banknumber')}
              value={state.company.banknumber}
              onChange={this.handleChange}
              style={{ width: 180 }}
              required
            />
          </div>
          <div>
            <h3>IBAN</h3>
            <input
              type="text"
              name={nameof<ICompany>('iban')}
              value={state.company.iban}
              onChange={this.handleChange}
              style={{ width: 180 }}
            />
          </div>
          <div>
            <h3>Swift</h3>
            <input
              type="text"
              name={nameof<ICompany>('swift')}
              value={state.company.swift}
              onChange={this.handleChange}
              style={{ width: 180 }}
            />
          </div>
        </div>
        <div className="spacer" />
        <h3>Betalningsdagar/Förfallodatum</h3>
        <input
          type="number"
          name={nameof<ICompany>('paymentdays')}
          value={state.company.paymentdays}
          onChange={this.handleChange}
          required
        />
        <div className="spacer" />
        <h3>Fakturastil</h3>
        <select
          name={nameof<ICompany>('style')}
          value={state.company.style}
          onChange={this.handleChange}
        >
          <option value="alxoptr">Alxoptr</option>
          <option value="alex">Alex</option>
          <option value="angelica">Angelica</option>
          <option value="default">Standard</option>
        </select>
        <div className="spacer" />
        {/*
    <h3>Valutor</h3>
    <ul>
      <li>
        <label>
          <input
            type="checkbox"
            name="currencies"
            value="SEK"
            onChange={this.handleCurrencyChange}
            checked={state.company.currencies.indexOf('SEK') !== -1}
          />
          {' SEK'}
        </label>
      </li>
      <li>
        <label>
          <input
            type="checkbox"
            name="currencies"
            value="NOK"
            onChange={this.handleCurrencyChange}
            checked={state.company.currencies.indexOf('NOK') !== -1}
          />
          {' NOK'}
        </label>
      </li>
      <li>
        <label>
          <input
            type="checkbox"
            name="currencies"
            value="EUR"
            onChange={this.handleCurrencyChange}
            checked={state.company.currencies.indexOf('EUR') !== -1}
          />
          {' EUR'}
        </label>
      </li>
    </ul>
    <div className="spacer" />
    */}

        <div className="submit">
          <button className="button">
            <span>Spara</span>
          </button>
        </div>
      </form>
    )
  }
}

export default CompanyEditor



// WEBPACK FOOTER //
// ./src/components/CompanyEditor/CompanyEditor.tsx